<template>
  <div>
    <VueContentLoading
      class="opacity-50 rounded-lg"
      v-bind="{ secondary, primary, height, width }"
    >
      <slot>
        <rect x="0" y="0" rx="4" ry="4" v-bind="{ height, width }" />
      </slot>
    </VueContentLoading>
  </div>
</template>

<script>
import { VueContentLoading } from 'vue-content-loading'

// TODO: Globally replace this component with components/loader/Skeleton.vue
// It's kinda a PITA to size this :/
export default {
  components: { VueContentLoading },

  props: {
    secondary: { type: String, default: '#f4f7fd' },
    primary: { type: String, default: '#e6e9f1' },
    height: { type: Number, default: 260 },
    width: { type: Number, default: 460 },
  },
}
</script>
